import React from "react";

import ArrowRight from "@uui/ArrowRight";
import CheckCircle from "@uui/CheckCircle";

import { Stack, Typography } from "@mui/material";

import Link from "@app/common/components/Link";

interface ProductFeatureListItemHrefProps {
  children: React.ReactNode;
  href?: string;
}

interface ProductFeatureListItemLinkToProps {
  children: React.ReactNode;
  linkTo?: string;
}

type ProductFeatureListItemProps =
  | ProductFeatureListItemHrefProps
  | ProductFeatureListItemLinkToProps;

const ProductFeatureListItem = ({
  children,
  ...props
}: ProductFeatureListItemProps) => {
  const { href, linkTo } = props as ProductFeatureListItemHrefProps &
    ProductFeatureListItemLinkToProps;

  return (
    <Stack direction="row" alignItems="flex-start" spacing="10px">
      <CheckCircle sx={{ color: "shades.meadow.500" }} />
      <Stack direction="row" sx={{ minHeight: "24px" }} alignItems="center">
        {href || linkTo ? (
          <Link
            href={href}
            to={linkTo}
            sx={{
              color: "shades.neutral.700",
              "&:hover": { color: "shades.primary.500", fontWeight: 500 },
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="bodyPrimaryReg">{children}</Typography>
              <ArrowRight
                sx={{
                  color: "shades.neutral.200",
                  width: "16px",
                  ".MuiLink-root:hover &": { color: "shades.primary.500" },
                }}
              />
            </Stack>
          </Link>
        ) : (
          <Typography
            variant="bodyPrimaryReg"
            sx={{ color: "shades.neutral.700" }}
          >
            {children}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default ProductFeatureListItem;
